import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";

const Led = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  //========================================================================
  // Simulation
  let simulation = false;
  let simValue = 0;

  try {
    simulation = props.style.properties.simulation;
    simValue = props.style.properties.simValue;
  } catch (error) {
    simulation = false;
  }

  if (simulation) {
    if (simValue == 1) {
      value.value = "1";
    } else {
      value.value = "0";
    }
  }

  //========================================================================
  // Auswerten, ob Aktiv
  let isActive;
  if (value.value === "1") {
    isActive = true;
  } else {
    isActive = false;
  }

  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
        visibility: props.props.visibility,
        borderRadius: "50%",
        backgroundColor: isActive
          ? props.element.activeColor
          : props.style.backgroundColor || "#333",
      }}
      title={
        props.element.tooltip
          ? language.displayText(props.element.tooltip) +
            (props.element.tooltip2
              ? "\n" + language.displayText(props.element.tooltip2)
              : "") +
            (props.element.tooltip3
              ? "\n" + language.displayText(props.element.tooltip3)
              : "")
          : language.displayText(value.name) +
            (props.element.tooltip2
              ? "\n" + language.displayText(props.element.tooltip2)
              : "") +
            (props.element.tooltip3
              ? "\n" + language.displayText(props.element.tooltip3)
              : "") +
            (globalVars.cyclicUpdate || globalVars.editor
              ? "\n" + ("Variable: " + props.props.variable)
              : "")
      }
    ></div>
  );
});

export default Led;
